import React from "react";
import {
  Box,
  Chip,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
} from "@material-ui/core";

const ALLOWED_COMPONENTS = [
  "CONCEPT_LABS",
  "COURSE",
  "PODCAST",
  "KEY_INSIGHTS",
  "RESEARCH_REPORT",
  "PROJECT_PLAN",
  "WHITE_PAPER",
  "BLOG",
  "NEWS_LETTER",
  "CASE_STUDY",
  "HANDOUT",
  "MODEL_DEVELOPMENT",
  "FORM",
  "MODEL_VALIDATION",
  "SESSION",
];

export default function ComponentsInput({
  value = [],
  onChange,
  label = "Components",
  helperText,
}) {
  const handleRemove = (val) => {
    onChange(value.filter((item) => item !== val));
  };

  return (
    <Box>
      <FormControl fullWidth>
        <InputLabel>{label}</InputLabel>
        <Select
          multiple
          value={value}
          onChange={(e) => onChange(e.target.value)}
          renderValue={(selected) => (
            <Box display="flex" flexWrap="wrap" gridGap={8}>
              {selected.map((val) => (
                <Chip
                  key={val}
                  label={val}
                  onDelete={() => handleRemove(val)}
                  // prevent click from opening the Select
                  onMouseDown={(e) => e.stopPropagation()}
                  color="quCreate"
                  variant="default"
                />
              ))}
            </Box>
          )}
        >
          {ALLOWED_COMPONENTS.filter((opt) => !value.includes(opt)).map(
            (opt) => (
              <MenuItem key={opt} value={opt}>
                {opt}
              </MenuItem>
            )
          )}
        </Select>
        {helperText && <FormHelperText>{helperText}</FormHelperText>}
      </FormControl>
    </Box>
  );
}
